module.exports = __webpack_public_path__ + "static/media/garage-open.4ebb5a48.svg";